import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge21 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='PGMグループとは？' fontWeight={700} />
                <p>
                    PGMグループとは、パシフィックゴルフマネージメント株式会社が運営するゴルフ場のことです。
                    <br />
                    日本国内において140以上のゴルフ場を保有しており、初心者から上級者まで幅広いゴルファーに楽しまれています。
                    <br />
                    特に、「GRANDPGM」と呼ばれる格式高いゴルフ場は、豪華な施設や洗練されたコースデザインで知られていて、特に人気のあるゴルフ場です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='PGMグループのゴルフ会員権の特典とは？' fontWeight={700} />
                <p>
                    PGMグループで用意されている様々な特典をご紹介します。
                    <br />
                    <Heading3 title='P-CAP' />
                    PGMグループのゴルフ会員権には、メンバーのゴルフライフがもっと楽しくなることを目的とし、PGMのスケールメリットを活かした「P-CAP」という会員特典プログラムが用意されています。
                    <ul className={s.group}>
                        <li>
                            <Heading3 title='優待料金プログラム' />
                        </li>
                        <li className={s.no_list_mark}>
                            全国のPGMグループのゴルフ場を優待料金でプレーすることができます。
                        </li>
                        <li>
                            <Heading3 title='レベルアップサポートプログラム' />
                        </li>
                        <li className={s.no_list_mark}>
                            ブリヂストンゴルフアカデミーの施設を特別優待で利用することができます。
                        </li>
                        <li>
                            <Heading3 title='住居移転サポートプログラム' />
                        </li>
                        <li className={s.no_list_mark}>
                            引越し先周辺のPGMグループゴルフ場に利用登録することで、メンバー料金でプレーすることができます。
                        </li>
                        <li>
                            <Heading3 title='追加入会サービスプログラム' />
                        </li>
                        <li className={s.no_list_mark}>
                            <ul className={s.group}>
                                <li>
                                    <Heading3 title='１）追加入会割引' />
                                </li>
                                <li className={s.no_list_mark}>
                                    所属クラブに3年以上在籍すると、P-CAP対象倶楽部に追加入会する場合、名義変更料が50％免除になります。
                                </li>
                                <li>
                                    <Heading3 title='２）家族入会割引' />
                                </li>
                                <li className={s.no_list_mark}>
                                    個人会員の3親等以内の親族が個人会員と同一の倶楽部に入会する場合、名義変更料が50％免除になります。
                                    <br />
                                    ※法人会員の登録者の3親等以内の親族には適用不可
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <br />
                    <Heading3 title='預託金充当制度' />
                    会員権証券に記載されている預託金金額の一部または全額を名義書換料に充当することができるという制度です。
                    <ul className={s.group}>
                        <li className={s.no_list_mark_exmaple}>（例）</li>
                        <li className={s.group_row}>
                            購入するゴルフ会員権の額面（預託金）が80万円、名義書換料が50万円の場合
                        </li>
                        <li className={s.group_row}>
                            預託金から50万円を名義書換料に充当すると、追加で名義書換料の費用負担は発生しません。
                        </li>
                        <li className={s.group_row}>
                            そのため、通常であれば名義書換料に加え、会員権代金と手数料がかかり、それらの総額が150万円だとした場合、
                            預託金充当制度で充当した分の50万円が差し引かれ、100万円で入会が可能となります。
                        </li>
                        <li className={s.group_row}>※充当後の新しい証券の額面は30万円になります。</li>
                    </ul>
                    <br />
                    <Heading3 title='年次会員' />
                    登録ゴルフ場を優待料金でプレーすることができます。
                    <br />
                    ※ゴルフ場や登録種別により登録料金や有効期間が異なります。
                    <br />
                    <Heading3 title='プレミアムステージ会員' />
                    <ul className={s.no_padding_group}>
                        <li className={s.no_list_mark}>
                            65歳以上のメンバーが配偶者または3親等以内の親族の方に会員権を譲渡した後も、プレミアムステージ会員(優待登録会員)として、メンバーと同条件の利用日、料金にて利用することができます。
                        </li>
                        <li className={s.no_list_mark}>※会員と同額の年会費が必要となります。</li>
                        <li className={s.no_list_mark}>
                            <Heading3 title='プレミアムステージ会員になるための条件' />
                        </li>
                        <li className={s.no_list_mark}>
                            <ul className={s.group2}>
                                <li className={s.no_list_mark}>１．個人会員</li>
                                <li className={s.no_list_mark}>２．年会費の未納がないこと</li>
                                <li className={s.no_list_mark}>３．在籍5年以上</li>
                                <li className={s.no_list_mark}>４．年齢65歳以上</li>
                                <li className={s.no_list_mark}>５．名義変更手続きと同時に入会申込手続きを行うこと</li>
                                <li className={s.no_list_mark}>
                                    ※ゴルフ場により条件が異なるため詳しくは各ゴルフ場にお問合せください。
                                </li>
                            </ul>
                        </li>
                    </ul>
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='PGMグループのおすすめのゴルフ場は？' fontWeight={700} />
                <p>
                    PGMグループの全国のゴルフ場一覧は
                    <a href='https://juchi.jp/courses?series_id=6' className={s.link}>
                        こちら
                    </a>
                    よりご確認ください。
                    <br />
                    その中でも弊社でよくお取引のあるゴルフ場の一部をご紹介します。
                </p>
                <Heading3 title='PGMのコースを一部ご紹介' />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/73'>総武カントリークラブ</a>
                </div>
                総武カントリークラブは、総武コース（27ホール）、印旛コース（18ホール）、北コース（9ホール）からなる合計54ホールの林間コースとなっています。
                <br />
                特に総武コースは過去日本オープン、サントリーオープン、日本プロなど数々のビッグトーナメントの舞台となっていて、会員の利用率も高いコースです。
                <br />
                フェアウェイが広く距離もたっぷりあり、飽きさせないコース設計になっていて、印旛コースは乗用カート、北コースは手引きカートでのプレーが楽しめます。
                <br />
                2011年にクラブハウスがリニューアルしたり、東京からのアクセスも良好だったりと関東でも人気のコースです。
                <br />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/493'>茨木国際ゴルフ倶楽部</a>
                </div>
                茨木国際ゴルフ倶楽部は、東・西・北の3つ（計27H）のコースがあり、東・西コースは「佐藤儀一」による設計、北コースは「上田治」による設計です。
                <br />
                東コースは四季折々の表情を見せる林間コースとなっており、西コースはフラットでありながら戦略性が高いコース、北コースは雄大なフェアウェイから大阪市内を一望できる特別なコースです。
                <br />
                冷房付きのカートがあったり、レストランは270度窓ガラス張りで眺めも楽しめるため、気持ちよくプレーができると関西で人気のゴルフ場の一つです。
                <br />
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/658'>PGMゴルフリゾート沖縄</a>
                </div>
                PGMゴルフリゾート沖縄は、青木功プロが改造監修を手掛けた全27Hのコースです。
                <br />
                ターコイズブルーに輝く東シナ海を見下ろす丘陵地にあり、本部半島や伊江島まで見渡せる壮大な景観となっています。
                <br />
                フェアウェイはフラットで幅広く、特にショートホールは地形を巧みに織りこみ、各ホールが独特の個性を出しています。
                <br />
                南国の花の名を冠した各コースはそれぞれの地形を活用して作られ、2017年11月開催 HEIWA×PGM
                CHAMPIONSHIPトーナメントでドラマを生んだ好評のチャンピオンコースです。
                <br />
            </section>

            <section className={s.section}>
                <Heading2 title='PGMグループの会員権をご購入された会員様の声' fontWeight={700} />
                <p>
                    住地ゴルフにて
                    <a href='https://juchi.jp/courses/530' className={s.link}>
                        大宝塚ゴルフクラブ
                    </a>
                    の会員権をご購入された会員様にインタビューさせていただきました。
                    <br />
                    ぜひ会員権のご購入にお役立てください。
                    <br />
                    <br />
                    大宝塚ゴルフクラブ会員様の声は
                    <a href='https://juchi.jp/member_voices/10' className={s.link}>
                        こちら
                    </a>
                    。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    上述のように、PGMグループでは他にはない特有の特典が多数あります。
                    <br />
                    また、日本全国にゴルフ場があるため、将来的に転勤がある方や複数会員権を所有したい方からも人気を集めています。
                    <br />
                    具体的なコースの特徴や売買状況については、お気軽に弊社にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge21;
